import { useContext, useEffect } from "react";
import ReclamosForm from "../reclamosForm/ReclamosForm";
import ReclamoEnviadoComponent from "../reclamoEnviado/ReclamoEnviado";
import Appbar from "../layouts/Appbar";
import ReclamoContext from "../../context/reclamo/reclamoContext";
import TokenContext from "../../context/Token/TokenContext";
// import Spinner from '../../Utils/Spinner';

const Home = ({history}) => {
  const reclamoContext = useContext(ReclamoContext);
  const { enviado } = reclamoContext;
  // const { enviado, data_usuario } = reclamoContext;
  
  const tokenContext = useContext(TokenContext);
  const { Get_Token_F, token, Active_Token_F, active_token } = tokenContext;

  const tokenacces = localStorage.getItem("token");

  // useEffect(() => {
  // //   if(data_usuario.length !== 0){
  // //     window.open(
  // //       `${"https://reclamosdesa-apb.superdesalud.gob.cl/home"}?run_atu=${
  // //         data_usuario.run
  // //       }&dv_atu=${data_usuario.dv}&nombres_atu=${
  // //         data_usuario.nombre
  // //       }&apellido_p_atu=${data_usuario.apellido_p}&apellido_m_atu=${
  // //         data_usuario.apellido_m
  // //       }`,
  // //       "_self"
  // //     );
  // //   }
  // // }, [data_usuario])


  // // useEffect(() => {


  //     // window.gtag("event", "formulario", {
  //     // event_category: "access",
  //     // event_label: "formulario"
  // }, [tokenacces]);

  return (
    <div className="pt-5 pb-3" style={{ backgroundColor: "#e2e2e2" }}>
      <div className="bg-white mt-5 mb-5 mx-4">
        {enviado === false ? (
          <>
            <Appbar history={history}/>
            <ReclamosForm history={history}/>
          </>
        ) : (
          <>
            <Appbar history={history}/>
            <ReclamoEnviadoComponent history={history}/>
          </>
        )}
      </div>
    </div>
    // <div className="pt-5 pb-3" style={{ backgroundColor: "#e2e2e2" }}>
    //   <div className="bg-white mt-5 mb-5 mx-4">
    //     {enviado === false ? (
    //       <>
    //         <Appbar history={history}/>
    //         <ReclamosForm history={history}/>
    //       </>
    //     ) : (
    //       <>
    //         <Appbar history={history}/>
    //         <ReclamoEnviadoComponent history={history}/>
    //       </>
    //     )}
    //   </div>
    // </div>
    // <Spinner/>
  );
};

export default Home;